// ── CallRegister 제출·수정·삭제·킵 액션 훅 ──────────────────────────────────
// 2026-10-13 356줄을 300줄 규칙으로 나눴다(함수 본문은 글자 그대로, 동작 변화 0). 이 파일은 조립만 한다:
//   callRegisterCreateActions.js — applyNaver · onPasteNaver · onSubmit(신규 등록)
//   callRegisterEditActions.js   — onEditSave · onDelete · onToggleKeep · openEditModal
//   callRegisterKeepActions.js   — openKeepReleaseModal · onKeepMemoSave · onKeepReleaseAssign · onKeepReleaseCancelVisit
// 여기 남은 것: 최신 콜 다시 읽기(getCallDetailEndpoint·fetchLatestCall) — 수정 창·킵 해제 창이 같이 쓴다.

import { apiClient } from '../../../api/apiClient';
import { createCallCreateActions } from './callRegisterCreateActions';
import { createCallEditActions } from './callRegisterEditActions';
import { createCallKeepActions } from './callRegisterKeepActions';

export function useCallRegisterSubmit(core, opts) {
  const { adminMode, adminApiBase, showToast } = opts;

  function getCallDetailEndpoint(callId) {
    if (adminMode) {
      // 목록 엔드포인트(`${adminApiBase}/calls`)와 동일 컨벤션 + /:id.
      //   PINE  → /api/admin/tm/calls/:id
      //   제주  → /api/admin/tm-jeju/calls/:id
      //   외부  → /api/admin/ext/{code}/tm-calls/calls/:id
      // (기존엔 `${adminApiBase}/:id` 라 PINE/제주에서 '/calls' 가 빠져 404 → 수정 시
      //  "최신 콜 데이터를 불러오지 못했습니다" 오류가 났음.)
      return `${adminApiBase}/calls/${callId}`;
    }
    return `/api/tm/calls/${callId}`;
  }

  async function fetchLatestCall(row) {
    const callId = Number(row?.id);
    if (!Number.isInteger(callId) || callId <= 0) return null;
    const res = await apiClient.get(getCallDetailEndpoint(callId));
    if (!res.ok) {
      showToast(res.data?.message || '최신 콜 데이터를 불러오지 못했습니다.', 'error');
      return null;
    }
    return res.data?.call || row;
  }

  // 킵 해제 창 열기를 수정 저장(onEditSave)이 부르므로 킵 액션을 먼저 만든다
  const keep = createCallKeepActions(core, opts, fetchLatestCall);
  const edit = createCallEditActions(core, opts, fetchLatestCall, keep.openKeepReleaseModal);
  const create = createCallCreateActions(core, opts);

  return {
    applyNaver: create.applyNaver, onPasteNaver: create.onPasteNaver,
    openEditModal: edit.openEditModal,
    onSubmit: create.onSubmit, onEditSave: edit.onEditSave, onDelete: edit.onDelete, onToggleKeep: edit.onToggleKeep,
    openKeepReleaseModal: keep.openKeepReleaseModal, onKeepMemoSave: keep.onKeepMemoSave,
    onKeepReleaseAssign: keep.onKeepReleaseAssign, onKeepReleaseCancelVisit: keep.onKeepReleaseCancelVisit,
  };
}
